module.exports = __webpack_public_path__ + "img/DE00114.fdfb9c0a.png";